/**
 * @file:
 * @author: wence
 */

import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {connect} from 'react-redux';
import './guidePage.less';

class GuidePage extends PureComponent {
    static propTypes = {
        isLogin: PropType.bool,
        match: PropType.object,
        history: PropType.object
    }

    constructor(props) {
        super(props);

        if (this.isPC()) {
            const url = '/haoma/guide' + location.search;
            window.location.href = url;
        }
    }

    componentDidMount() {
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    }

    componentWillMount() {
        window.onpageshow = null;
    }

    pushUrl(url) {
        window.location.href = this.props.isLogin ? url : this.loginUrl(url);
    }

    render() {
        const phone = this.getParams().phone || '';

        return (
            <div className="number-guide">
                <p className="number-guide-tips">温馨提示</p>
                <p className="number-guide-des">号码申诉和举报需要在登录状态下才能办理。</p>
                <p className="number-guide-des">
                    您可以点击界面右上角
                    <img src={require('../../asset/svg/spu_menu_account.svg')} alt="logo" />
                    看和管理登录状态。
                </p>

                <a onClick={this.pushUrl.bind(this, `/m/haoma/report?phone=${phone}`)}
                    className="number-options-card first-card">
                    <div className="card-icon">
                        <img src={require('../../asset/svg/icon_saoraodianhuajubao.svg')} alt="icon" />
                    </div>
                    <div className="card-title">骚扰电话举报</div>
                    <div className="card-btn">立即举报</div>
                </a>

                <a onClick={this.pushUrl.bind(this, `/m/haoma/appeal/company?phone=${phone}&selectType=2`)}
                    className="number-options-card">
                    <div className="card-icon">
                        <img src={require('../../asset/svg/icon_qiyehaomashensu.svg')} alt="icon" />
                    </div>
                    <div className="card-title">企业号码申诉</div>
                    <div className="card-btn">立即申诉</div>
                </a>

                <a
                    onClick={this.pushUrl.bind(this, `/m/haoma/appeal/person?phone=${phone}&selectType=2`)}
                    className="number-options-card last-card">
                    <div className="card-icon">
                        <img src={require('../../asset/svg/icon_gerenhaomashensu.svg')} alt="icon" />
                    </div>
                    <div className="card-title">个人号码申诉</div>
                    <div className="card-btn">立即申诉</div>
                </a>
            </div>
        );
    }
}
export default connect(state => ({
    isLogin: state.userLoginstate && state.userLoginstate.status === 0
}))(GuidePage);



// WEBPACK FOOTER //
// ./src/containers/numberOptions/guidePage.js